const outerDivStyles = {
  position: 'relative',
  width: '100%'
};

const outerSpanStyles = {
  position: 'relative',
  display: 'inline-block',
  width: '48px',
  height: '20px',
  paddingRight: '2px',
  verticalAlign: 'middle',
  cursor: 'pointer'
};


const labelStyles = (checked) => {
  let background = checked ? "#319bd5" : "#EEEEEE";
  return {
    textAlign: 'left',
    color: '#888888',
    fontWeight: '400',
    display: 'inline-block',
    height: '20px',
    width: '100%',
    background,
    border: '1px solid #DDD',
    borderRadius: '20px',
    margin: '0'
  };
};

const checkSpanStyles = (checked) => {
  return {
    content: '',
    display: 'inline-block',
    verticalAlign: 'middle',
    background: 'no-repeat',
    backgroundSize: 'auto',
    width: checked ? '20px' : '0px',
    height: '7px',
    textAlign: 'center',
    lineHeight: '13px'
  };

};

const spanStyles = (disabled) => {
  return {
    marginTop: '-4px',
    display: 'inline-block',
    cursor: disabled ? 'default' : 'pointer',
    height: '24px',
    width: '24px',
    backgroundColor: disabled ? 'rgb(220, 220, 220)': '#fbfbfb',
    border: '1px solid #ddd',
    borderRadius: '13px',
    boxShadow: '0 1px 1px rgba(0,0,0,0.45)'
  }
};

export {
  outerSpanStyles,
  outerDivStyles,
  labelStyles,
  spanStyles,
  checkSpanStyles
}